import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import '../../cssfiles/homepage.css'

export default function Switchcard() {
    const theme = useSelector((state) => state.themedata.theme)
    const [status, setStatus] = useState(false)

    const handlechangestatus = () => {
        setStatus(!status)
    }
    return(
        <div style={{height: 'calc(100% - 55px)', width: 'calc(100% - 15px)', padding: '10px', overflow: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <div
                style={{
                    border: "15px solid",
                    borderColor: theme === "dark" ? '#FFFFFF': '#3C3C3C',
                    borderRadius: "100px",
                    height: "100px",
                    width: "100px",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0) 8px -21px 0px -154px inset'
                }}
                onClick={handlechangestatus} 
            >
                <PowerSettingsNewIcon style={{fontSize: '80px', color: status ? '#DC272D' : '#00943D', stroke: status ? '#DC272D' : '#00943D', strokeWidth: 0.8, boxShadow: 'rgba(0, 0, 0, 0) 8px -21px 0px -154px'}}/>
            </div>
        </div>
    )
}